export interface CrmVehicleRemoveDeviceRequestDto {
  /** идентификатор устройства */
  deviceId: string;
}
